import Context from "./context";
import PropTypes from "prop-types";
import { useUrlState } from "./useUrlState";

const UrlProvider = ({ children }) => (
  <Context.Provider value={useUrlState()}>{children}</Context.Provider>
);

UrlProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

export default UrlProvider;
